import { BrowserModule, HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, Injectable } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import { AuthGuard } from './guards/auth-guard.guard';
import { TokenInterceptorService } from './services/token-interceptor.service';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { FiltroModule } from './components/filtro/filtro.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS } from './utils/moment-config-datepicker';
import { FabButtonModule } from './components/fab-button/fab-button.module';
import {MatDialogModule} from '@angular/material/dialog';
import { ModalFormModule } from './pages/cliente/modal-form/modal-form.module';
import { ModalNegocioModule } from './pages/negocios/modal-negocio/modal-negocio.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EstatisticasModule } from './components/estatisticas-veiculo/estatisticas-veiculo.module';
// import { AlertConfirmComponent } from './components/alert-confirm/alert-confirm.component';
// import { EstatisticasVeiculoComponent } from './components/estatisticas-veiculo/estatisticas-veiculo.component';
import { AlertConfirmModule } from './components/alert-confirm/alert-confirm.module';
import { FechamentoService } from './services/fechamento.service';
// import { GtagModule } from 'angular-gtag';
import { SobreComponentModule } from './components/sobre/sobre.module';
import { ApiInterfaceService } from 'src/app/services/api/api-interface.service';
import { ApiApiceService } from 'src/app/services/api/api-apice.service';
import { ModalVideoIntroModule } from './components/modal-video-intro/modal-video-intro.module';
import { LinkVideoModule } from './components/link-video/link-video.module';
import { ModalFechamentoModule } from './components/modal-fechamento/modal-fechamento.module';
import { ModalDocsModule } from './pages/documentos/modal-docs/modal-docs.module';
import { ModalTarefaModule } from 'src/app/components/tarefa/modal-tarefa/modal-tarefa.module';
import { PageModules } from 'src/app/utils/pageModules';
import { MatMenuModule } from '@angular/material/menu';
import { PerfilUsuarioModule } from 'src/app/components/perfil-usuario/perfil-usuario.module';
import { MenuNovaCotacaoComponent } from './components/menu-nova-cotacao/menu-nova-cotacao.component';

import { ToolBarActionsModule } from './components/tool-bar-actions/tool-bar-actions.module';
import { ConstantRecalculo} from 'recalculo';
import { AjustePorSeguradoraService } from 'ajuste-por-seguradora';
@Injectable()
export class HammerConfig extends HammerGestureConfig  {
  buildHammer(element: HTMLElement): HammerManager {
     return new Hammer.Manager(element, {
      touchAction: 'auto',
      inputClass: window.innerWidth > 870 ? Hammer.PointerEventInput : Hammer.TouchInput,
      recognizers: [
        [Hammer.Pan, {
          direction: Hammer.DIRECTION_ALL
        }],
        [Hammer.Press],
        [Hammer.Swipe, {direction: Hammer.DIRECTION_HORIZONTAL}],
        [Hammer.Tap, {enable: false}]
      ]
    });
  }
}

@NgModule({
  declarations: [
    AppComponent,
    // AlertConfirmComponent,
    // EstatisticasVeiculoComponent,
    MenuNovaCotacaoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HammerModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: true,  registrationStrategy: 'registerWhenStable' }),
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    ModalDocsModule,
    FiltroModule,
    MatDatepickerModule,
    FabButtonModule,
    MatDialogModule,
    ModalFormModule,
    ModalNegocioModule,
    ModalTarefaModule,
    NgbModule,
    SobreComponentModule,
    ModalVideoIntroModule,
    LinkVideoModule,
    ModalFechamentoModule,
    PageModules,
    PerfilUsuarioModule,
    MatMenuModule,
    EstatisticasModule,
    AlertConfirmModule,
    ToolBarActionsModule,
    // MenuNovaCotacaoComponent
    // GtagModule.forRoot({ trackingId: 'GTM-P9JGF8X', trackPageviews: true }),
    // PixelModule.forRoot({ enabled: true, pixelId: '171384461741729' })

  ],
  providers: [
    AuthGuard,
    // AlertConfirmService,
    // EstatisticasVeiculoService,
    FechamentoService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: ApiInterfaceService, useClass: ApiApiceService },
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig},
    DeviceDetectorService,
    ConstantRecalculo
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
